import Search from 'Components/Common/Search/Search';
import useSuggestion from 'Hooks/useSuggestion';
import React from 'react';
import { Col } from 'react-bootstrap';

export default function TitleSearch(): JSX.Element {
  const {
    artistOptions,
    titleOptions,
    cdOptions,
    loadingArtist,
    loadingTitle,
    handleLoadMore,
    handleFocusInput,
    loadingCD,
    handleEnterPrimary,
    handleClickItemPrimary,
  } = useSuggestion({
    validQueryObj: {
      validArtist: {
        artistIds: undefined,
        queryArtist: undefined,
        artistId: undefined,
        queryTitle: undefined,
        titleIds: undefined,
      },
      validTitle: {
        queryTitle: undefined,
        titleIds: undefined,
        queryCD: undefined,
        cdIds: undefined,
      },
    },
    fetchList: ['artist', 'title', 'cd'],
  });

  return (
    <>
      <Col md="3" className="px-1 ps-3">
        <Search
          label="アーティスト"
          labelMd="12"
          colMd="12"
          placeholder="検索"
          showIcon
          classLabel="px-0"
          rowClass="w-100"
          colClass="px-0"
          searchKey="queryArtist"
          onEnter={() => handleEnterPrimary('queryArtist')}
          onClickResult={handleClickItemPrimary}
          options={artistOptions.options || []}
          loading={loadingArtist}
          onLoadMore={() => handleLoadMore('pageArtist')}
          onFocusInput={() => {
            handleFocusInput('queryArtist', 'pageArtist');
          }}
        />
      </Col>
      <Col md="3" className="px-1 ps-3">
        <Search
          label="タイトル"
          labelMd="12"
          colMd="12"
          placeholder="検索"
          showIcon
          classLabel="px-0"
          rowClass="w-100"
          colClass="px-0"
          searchKey="queryTitle"
          onEnter={() => handleEnterPrimary('queryTitle')}
          onClickResult={handleClickItemPrimary}
          options={titleOptions.options || []}
          loading={loadingTitle}
          onLoadMore={() => handleLoadMore('pageTitle')}
          onFocusInput={() => {
            handleFocusInput('queryTitle', 'pageTitle');
          }}
        />
      </Col>
      <Col md="3" className="px-1 ps-3">
        <Search
          label="CD商品名(バリエーション)"
          labelMd="12"
          colMd="12"
          placeholder="検索"
          showIcon
          classLabel="px-0"
          rowClass="w-100"
          colClass="px-0"
          searchKey="queryCD"
          onEnter={() => handleEnterPrimary('queryCD')}
          onClickResult={handleClickItemPrimary}
          options={cdOptions.options || []}
          loading={loadingCD}
          onLoadMore={() => handleLoadMore('pageCD')}
          onFocusInput={() => {
            handleFocusInput('queryCD', 'pageCD');
          }}
        />
      </Col>
    </>
  );
}
